import { fetchJson } from '~/utils/fetch-json-v2';

interface OrganizationProfile {
  legal_name: string;
  tax_id: string;
  business_type: string;
  incorporation_country_code: string;
  incorporation_state: string;
  address_line1: string;
  postal_code: string;
  // biome-ignore lint/suspicious/noExplicitAny: places field structure is dynamic and varies by organization type
  places: any[];
}

interface OrganizationMetadata {
  industry: string;
}

interface CreateOrganizationBody {
  org_type: 'business' | 'dao';
  profile: OrganizationProfile;
  metadata: OrganizationMetadata;
}

export async function createOrganizationApi(body: CreateOrganizationBody) {
  return fetchJson('/orgs', {
    method: 'POST',
    body: body,
  });
}
